var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedValue)?_c('Flex',{attrs:{"absolute":"","right-0":"","mx-1":"","clear-selection":""}},[_c('Icon',{staticClass:"cursor-pointer",attrs:{"src":"material/clear"},on:{"click":_vm.clearSelection}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }